import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { isError, isLoading } from 'src/app/shared/utils/async';

import { ErrorState, ListHeading, LoadingState } from '../../shared/components';
import type { SuggestedPetitionSourceLocation } from '../../shared/types';

import { VictoriousPetitionsList } from './components/VictoriousPetitionsList';
import { useVictoriousPetitions } from './hooks/useVictoriousPetitions';

type Props = {
	petitionSlugOrId?: string;
	sourceLocation: SuggestedPetitionSourceLocation;
};

export const VictoriousPetitions: React.FC<Props> = ({ petitionSlugOrId, sourceLocation }) => {
	const {
		data: { petitionsState },
	} = useVictoriousPetitions({ petitionSlugOrId });

	if (isLoading(petitionsState)) {
		return (
			<div data-nosnippet>
				<ListHeading title={translationKey('corgi.petition.details.suggested_victorious_petitions.header')} />
				<LoadingState />
			</div>
		);
	}

	if (isError(petitionsState)) {
		return (
			<div data-nosnippet>
				<ListHeading title={translationKey('corgi.petition.details.suggested_victorious_petitions.header')} />
				<ErrorState />
			</div>
		);
	}

	if (petitionsState.petitions.length === 0) return null;

	return (
		// https://iloveseo.com/seo/use-data-nosnippet-attribute-to-remove-text-in-google-serp-snippet/
		<div data-nosnippet>
			<ListHeading title={translationKey('corgi.petition.details.suggested_victorious_petitions.header')} />
			<VictoriousPetitionsList
				petitions={petitionsState.petitions}
				parentPetitionId={petitionsState.parentPetitionId}
				sourceLocation={sourceLocation}
			/>
		</div>
	);
};
